Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = mutuallyExclusiveRequired;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mutuallyExclusiveRequired(propMapping) {
  var keys = Object.keys(propMapping);
  if (keys.length < 2) {
    throw new Error('mutuallyExclusiveRequired requires at least two props');
  }
  return keys.reduce(function (propTypes, key) {
    return Object.assign({}, propTypes, _defineProperty({}, key, function () {
      function validator(props, propName, componentName) {
        var presentProps = Object.keys(props).filter(function (prop) {
          return Boolean(propMapping[prop]);
        });
        if (presentProps.length === 0) {
          return new Error(String(componentName) + ' requires one of ' + String(keys.join(' and ')) + ', but none were provided');
        }
        if (presentProps.length > 1) {
          return new Error(String(componentName) + ' requires one of ' + String(keys.join(' and ')) + ', but ' + String(presentProps.join(' and ')) + ' were provided');
        }

        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }

        return propMapping[propName].apply(propMapping, [props, propName, componentName].concat(rest));
      }

      return validator;
    }()));
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/mutuallyExclusiveRequired.js
// module id = 256
// module chunks = 168707334958949